/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback, useMemo } from 'react';
import { MenuIdAppSwitcher } from '@jira/navigation-apps__constants/src/MenuIdAppSwitcher.tsx';
import { useNavigationItemAnalytics } from '@jira/navigation-apps__topnav-common/src/controllers/navigation-item-analytics/main.tsx';
import { NAVIGATION_ITEM_ID__APP_SWITCHER } from '@jira/navigation-apps__topnav-common/src/constants.tsx';
import { useTopMenus } from '@jira/navigation-apps__common/src/controllers/top-menus/index.tsx';
import { useEntryPointButtonTrigger } from '@jira/platform__entry-point-button-trigger/src/index.tsx';
import { JiraEntryPointContainer } from '@jira/platform__entry-points-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import AtlassianSwitcherPrefetchTrigger from '@atlassian/switcher/prefetch-trigger';
import { setSwitcherRenderStartMark } from '@atlassian/switcher/timings';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { AppSwitcherIntegrationEntrypoint } from '../integration/AppSwitcherIntegrationEntrypoint.entrypoint.tsx';
import { AppSwitcherPlaceholderButton } from './AppSwitcherPlaceholderButton.tsx';
import { AppSwitcherPlaceholderWithLoadingPopup } from './AppSwitcherPlaceholderWithLoadingPopup.tsx';

export function AppSwitcherTrigger(): React.JSX.Element {
	const [isOpen, { on: openMenu, off: closeMenu }] = useTopMenus(MenuIdAppSwitcher);

	const cloudId = useCloudId();
	const triggerAnalytics = useNavigationItemAnalytics({
		navigationItemId: NAVIGATION_ITEM_ID__APP_SWITCHER,
	});
	const onOpen = useCallback(() => {
		setSwitcherRenderStartMark();
		openMenu();
		triggerAnalytics();
	}, [openMenu, triggerAnalytics]);

	const entryPointParams = useMemo(
		() => ({ isOpen, onClose: closeMenu, onOpen }),
		[isOpen, closeMenu, onOpen],
	);
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		AppSwitcherIntegrationEntrypoint,
		entryPointParams,
	);
	const entrypointRef = useEntryPointButtonTrigger(entryPointActions);

	return (
		<AtlassianSwitcherPrefetchTrigger cloudId={cloudId} product="jira">
			{!isOpen ? (
				<AppSwitcherPlaceholderButton onOpen={onOpen} ref={entrypointRef} />
			) : (
				<JiraEntryPointContainer
					entryPointReferenceSubject={entryPointReferenceSubject}
					id="app-switcher-content"
					packageName="jira-navigation-apps-topnav4-app-switcher"
					fallback={<AppSwitcherPlaceholderWithLoadingPopup />}
					errorFallback="flag"
					runtimeProps={entryPointParams}
				/>
			)}
		</AtlassianSwitcherPrefetchTrigger>
	);
}
